import SyncStatus from "./syncStatus";
import UserSyncStatus from "./userSyncStatus";

const checkIsSyncInProgress = (userSyncStatus: UserSyncStatus[]) => {
  return (
    userSyncStatus.filter((s) => s.syncStatus === SyncStatus.InProgress)
      .length > 0
  );
};

const checkIsSyncError = (userSyncStatus: UserSyncStatus[]) => {
  return (
    userSyncStatus.filter((s) => s.syncStatus === SyncStatus.Error).length > 0
  );
};

const userSyncManager = {
  checkIsSyncInProgress,
  checkIsSyncError,
};

export default userSyncManager;
